module.exports = __webpack_public_path__ + "img/evroset.28f57083.jpg";